import React, { useEffect } from "react";

import { Box } from "@chakra-ui/react";

import { ErrorBoundary } from "@sentry/react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import { ErrorAlerts } from "@/components/common/errors/ErrorAlerts";
import { GenericErrorMessage } from "@/components/common/errors/GenericErrorMessage";
import {
  bootstrapApp,
  selectMinorBootstrapErrors
} from "@/store/app/bootstrap/bootstrap";

export const RootRoute: React.FC = () => {
  const dispatch = useDispatch();

  const minorBootstrapErrors = useSelector(selectMinorBootstrapErrors);

  // Placeholder for now until we have a proper error handling mechanism
  useEffect(() => {
    dispatch(bootstrapApp());
  }, [dispatch]);

  return (
    <ErrorBoundary
      fallback={({ error, componentStack }) => (
        <Box p={8} h="100vh" overflowY="scroll">
          <GenericErrorMessage
            error={error as Error}
            componentStack={componentStack}
          />
        </Box>
      )}
    >
      <React.Fragment>
        <ErrorAlerts errors={minorBootstrapErrors} />

        <Outlet />
      </React.Fragment>
    </ErrorBoundary>
  );
};
